
export function checkPropertiesIsHaveValueWithIncludes(obj: Record<string, any>, includes: string[]): { status: boolean, error?: string } {
    for (const key of Object.keys(obj)) {
        if (!includes.includes(key)) {
            continue;
        }

        const value = obj[key];
        if (value == null || value === '' || value === 'undefined') {
            return { status: false, error: `Property '${key}' is empty or undefined` };
        }

        if (Array.isArray(value) && value.length === 0) {
            return { status: false, error: `Property '${key}' is an empty array` };
        }
    }
    return { status: true };
}


export function isEmpty(value: any): boolean {
    if (value == null || value === '' || value === 'undefined') {
        return true;
    }

    if (Array.isArray(value) && value.length === 0) {
        return true;
    }
    
    if (typeof value === 'object' && Object.keys(value).length === 0) {
        return true;
    }
    
    return false;
}
